import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { motion } from 'framer-motion';
import { Breadcrumbs, Button } from '@material-ui/core';
import { useWhatIf } from './WhatIfProvider';

function FigurePathComponent(props) {
	const { figurePath, changeFigure } = useWhatIf();

	if (figurePath.length === 0) return <></>;
	const last = (index) => { return index === figurePath.length - 1; };

	return (
		<motion.div className='flex gap-4 items-center justify-center text-11' initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0, transition: { delay: 0.3 } }}>

			<div className='flex items-center text-11 font-medium opacity-25'>Navigate:</div>

			<Breadcrumbs
				classes={{ ol: 'items-center', li: 'flex items-center', separator: 'flex items-center mx-4' }}
				maxItems={2}
				separator={<div className='w-1 flex items-center justify-center'><NavigateNextIcon style={{ fontSize: 18 }} /></div>}
				aria-label='breadcrumb'>

				{figurePath.map((figure, index) => <Button className='min-w-0 px-6 py-4 text-11 leading-tight' size='small' key={figure} color='inherit' onClick={() => changeFigure(figure)} disabled={last(index)}>{figure}</Button>)}

			</Breadcrumbs>

		</motion.div>
	);
}

export default FigurePathComponent;
